import PropTypes from 'prop-types';
import React from 'react';

import Carousel from '../../common/carousel/Carousel';
import Card from '../../common//card/Card';

require('./style.scss');

export default class Gallery extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPhotoIndex: 0,
    };
  }

  renderMainImage(photoIndex) {
    return (
      <div
        className="gallery-main-image"
        style={{ backgroundImage: `url(${this.props.photos[photoIndex]})` }}
      />
    );
  }


  renderThumbnail(photoUrl, index) {
    return (
      <Carousel.Slide key={photoUrl}>
        <div
          className="gallery-thumbnail"
          onClick={() => this.setState({ currentPhotoIndex: index })}
          style={{ backgroundImage: `url(${photoUrl})` }}
        />
      </Carousel.Slide>);
  }

  render() {
    return (
      <div>
        <Card>
          <Card.Media media={this.renderMainImage(this.state.currentPhotoIndex)} />
          <Card.Content>
            <Card.Body>
              <Carousel
                arrows
                onSlideChange={(slide, currentPhotoIndex) => this.setState({ currentPhotoIndex })}
                slideWidth={150}
                className="gallery"
              >
                {this.props.photos.map((photoUrl, index) => this.renderThumbnail(photoUrl, index))}
              </Carousel>
            </Card.Body>
          </Card.Content>
        </Card>
      </div>
    );
  }
}

Gallery.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.string),
};

module.exports = Gallery;



// WEBPACK FOOTER //
// ./app/components/derived/gallery/Gallery.jsx